export default {
  UserManagementList: {
    Title: 'Quản lý người dùng',
    AddUser: 'Thêm người dùng',
    AddNewUser: 'Thêm người dùng mới',
    AddUserForUnit: 'Thêm người dùng của đơn vị',
    NoUserForUnit: 'Tất cả người dùng của đơn vị đã được thêm vào dữ liệu, nếu muốn thêm tài khoản mới chọn chức năng thêm người dùng mới.',
    HandOverAccount: 'Bàn giao tài khoản',
  },
  UserManagementDetail: {
    UserName: 'Tên người dùng *',
    Email: 'Email *',
    EmailNoRequired: 'Email',
    PhoneNumber: 'Số điện thoại *',
    PhoneNumberNoRequired: 'Số điện thoại',
    Role: 'Chọn vai trò',
    Agree: 'Đồng ý',
    PositionName: 'Chức vụ',
    FailSaveContent: 'Bạn cần chọn giá trị phân quyền vào dữ liệu cho tất cả người dùng.',
    NewUser: 'Người dùng mới',
    UserFromList: 'Người dùng trên danh sách',
    Info: 'Lựa chọn người dùng để bàn giao vai trò quản trị dữ liệu',
    NotAdmin: 'Bạn không có quyền thực hiện chức năng này.',
  },
};
